import React from "react";
import { Tag, Space } from "antd";
import { FlagOutlined } from "@ant-design/icons";

const isWipLabel = (title) => title?.toLowerCase() === "wip";

const IssueMetaTags = ({ labels = [], milestone }) => (
  <Space size={[4, 4]} wrap className="issue-meta-tags">
    {labels.map((label) => (
      <Tag
        key={label.title}
        color={isWipLabel(label.title) ? undefined : label.color || "blue"}
        className={`issue-tag${isWipLabel(label.title) ? " issue-tag--wip" : ""}`}
      >
        {label.title}
      </Tag>
    ))}
    {milestone?.title && (
      <Tag icon={<FlagOutlined />} color="green" className="issue-tag">
        {milestone.title}
      </Tag>
    )}
  </Space>
);

export default IssueMetaTags;
